import { useEffect, useState } from "react";

import { Button } from "primereact/button";
import { Dropdown } from "primereact/dropdown";
import { Tooltip } from "primereact/tooltip";
import { InputText } from "primereact/inputtext";
import { InputMask } from "primereact/inputmask";

import { ErrorOutline, CheckCircleOutline } from "@material-ui/icons";
import { useFormik } from "formik";

import CardSeplag from "../../components/CardSeplag";
import RotuloSeplag from "../../components/RotuloSeplag";

import { pesquisarAll } from "../../service/manterTiposCertidao";

// global
import { classNames, isFormFieldValid, getFormErrorMessage, printToast } from "../../config/global";

// Service
import { orgaoService } from "../../service/certidao";
import { pesquisarListaAtivos } from "../../service/ManterAmparoLegal";
import { validarValidarCertidao } from "../../service/ValidaCertidaoLegada";

const CertidaoViewDadosCertidao = ({ certidao, setCertidao }) => {

  const [form, setForm] = useState({
    ...certidao,
    dataAutenticCert: certidao.dataAutenticCert ? certidao.dataAutenticCert.trim() : "",
    dataCompensCert: certidao.dataCompensCert ? certidao.dataCompensCert.trim() : "",
    dataEmissaoCert: certidao.dataEmissaoCert ? certidao.dataEmissaoCert.trim() : "",
    dataEntregaCert: certidao.dataEntregaCert ? certidao.dataEntregaCert.trim() : "",
    dataQuitacaoCert: certidao.dataQuitacaoCert ? certidao.dataQuitacaoCert.trim() : "",
    dataUltimaCorrCert: certidao.dataUltimaCorrCert ? certidao.dataUltimaCorrCert.trim() : "",
    descProcessoSad: certidao.descProcessoSad ? certidao.descProcessoSad.trim() : "",
    numrProcessoAutenticacao: certidao.numrProcessoAutenticacao ? certidao.numrProcessoAutenticacao.trim() : "",
    numrProcessoCompensacao: certidao.numrProcessoCompensacao ? certidao.numrProcessoCompensacao.trim() : "",
    numrProcessoQuitacao: certidao.numrProcessoQuitacao ? certidao.numrProcessoQuitacao.trim() : "",
    numrProcessoSad: certidao.numrProcessoSad ? certidao.numrProcessoSad.trim() : "",
  });

  const [flagValidaDadosCertidao, setFlagValidaDadosCertidao] = useState(false);
  const [orgaos, setOrgaos] = useState([]);
  const [amparoLegal, setAmparoLegal] = useState([]);
  const [tipoCertidaoList, setTipoCertidaoList] = useState([]);

  const orgaoMaisRelevante = (listaOrgaos, nomeOrgao) => {
    let splitNomeOrgao = nomeOrgao.split(" ")

    let listNewOrgao = listaOrgaos
      .map((element) => {
        let cont = 0;
        for (let nome of splitNomeOrgao) {
          if (element.descOrgao.includes(nome)) {
            cont++;
          }
        }
        return { ...element, numeroRelevancia: cont }
      })
      .sort((a, b) => b.numeroRelevancia - a.numeroRelevancia)

    let orgao = listNewOrgao[0]
    delete orgao.numeroRelevancia
    return orgao
  }

  useEffect(() => {
    if (orgaos.length > 0 && certidao) {

      let orgao = orgaoMaisRelevante(orgaos, certidao.orgao ? certidao.orgao.descOrgao : certidao.orgaoLotacaoCs.nomeOrgao)


      setForm({
        ...certidao,
        dataAutenticCert: certidao.dataAutenticCert ? certidao.dataAutenticCert.trim() : "",
        dataCompensCert: certidao.dataCompensCert ? certidao.dataCompensCert.trim() : "",
        dataEmissaoCert: certidao.dataEmissaoCert ? certidao.dataEmissaoCert.trim() : "",
        dataEntregaCert: certidao.dataEntregaCert ? certidao.dataEntregaCert.trim() : "",
        dataQuitacaoCert: certidao.dataQuitacaoCert ? certidao.dataQuitacaoCert.trim() : "",
        dataUltimaCorrCert: certidao.dataUltimaCorrCert ? certidao.dataUltimaCorrCert.trim() : "",
        descProcessoSad: certidao.descProcessoSad ? certidao.descProcessoSad.trim() : "",
        numrProcessoAutenticacao: certidao.numrProcessoAutenticacao ? certidao.numrProcessoAutenticacao.trim() : "",
        numrProcessoCompensacao: certidao.numrProcessoCompensacao ? certidao.numrProcessoCompensacao.trim() : "",
        numrProcessoQuitacao: certidao.numrProcessoQuitacao ? certidao.numrProcessoQuitacao.trim() : "",
        numrProcessoSad: certidao.numrProcessoSad ? certidao.numrProcessoSad.trim() : "",
        orgao
      });

    }

    setFlagValidaDadosCertidao(certidao.tipoCertidaoValidada && certidao.amparoLegalObrigacao && certidao.orgao);
  }, [certidao, orgaos]);

  useEffect(() => {
    async function buscar() {
      orgaoService().then((res) => {
        setOrgaos(res);
      });

      pesquisarListaAtivos().then((res) => {
        setAmparoLegal(res);
      });

      pesquisarAll().then((res) => {
        setTipoCertidaoList(res);
      });
    }

    buscar();

  }, []);

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: form,
    validate: (data) => {
      let errors = {};

      // if (!data.orgao) {
      //   errors.orgao = "Novo orgão de origem obrigação é Obrigatório";
      // }

      if (!data.amparoLegalObrigacao) {
        errors.amparoLegalObrigacao = "Amparo legal obrigação é Obrigatório";
      }

      return errors;
    },
    onSubmit: async (data) => {
      validarValidarCertidao(data).then((res) => {
        setCertidao(res.validaCertidaoLegada);
        printToast({ summary: "Dados da certidão validados", detail: "Validados todos os campos da Obrigação/Certidão" });
      });
    },
  });

  return (
    <CardSeplag cardHeaderClassNames={`${flagValidaDadosCertidao ? "div_validado_header" : "div_naoValidado_header"}`}>
      <div className="p-col-12" style={{ display: "flex", justifyContent: "flex-start" }}>
        <h5>
          {" "}
          <strong> Validação</strong>
        </h5>
        {flagValidaDadosCertidao ? (
          <>
            <Tooltip target=".tooltip-icon-success" mouseTrack mouseTrackLeft={10} />
            <CheckCircleOutline className="tooltip-icon-success" style={{ color: "#067406", fontSize: "2rem" }} data-pr-tooltip="Dados da Certidão Validado" data-pr-position="top" />
          </>
        ) : (
          <>
            <Tooltip target=".tooltip-icon-warning" mouseTrack mouseTrackLeft={10} />
            <ErrorOutline className="tooltip-icon-warning" style={{ color: "#e95c09", fontSize: "2rem" }} data-pr-tooltip="Dados da Certidão não Validado" data-pr-position="top" />
          </>
        )}
      </div>
      <hr className="p-col-12" />
      <form className="p-col-12 p-grid" onSubmit={formik.handleSubmit}>
        <RotuloSeplag nome="Nº Certidão de Crédito:" cols="12 2">
          <label className="inputNumeroCertidao p-inputtext p-component p-disabled p-filled inputEditadonoSpan ">{certidao.numrCert ? ("0000" + String(certidao.numrCert)).slice(-10).replace(/(\d{2})?(\d{1})?(\d{6})?(\d{1})/, "$1.$2.$3-$4") : "00.0.000000-0"}</label>
        </RotuloSeplag>
        <RotuloSeplag nome="Tipo:" cols="12 2" style={{ marginTop: "15px" }}>
          <label className="p-inputtext p-component p-disabled p-filled inputEditadonoSpan">{certidao.tipoCertidao}</label>
        </RotuloSeplag>
        <RotuloSeplag nome="Tipo validado" cols="12 6">
          <Dropdown
            filter
            placeholder="Selecione..."
            id="tipoCertidaoValidada"
            name="tipoCertidaoValidada"
            optionLabel="nomeTipoCertidao"
            options={tipoCertidaoList}
            value={formik.values.tipoCertidaoValidada}
            onChange={(e) => {
              formik.handleChange(e);
            }}
            disabled={flagValidaDadosCertidao ? true : false}
            className={"campoTamanhoCompleto " + classNames({ "p-invalid": isFormFieldValid("tipoCertidaoValidada", formik) })}
          />
          {getFormErrorMessage("tipoCertidaoValidada", formik)}
        </RotuloSeplag>
        <hr className="p-col-12" />
        <RotuloSeplag nome="Amparo legal:" cols="12 6">
          <Dropdown
            filter
            id="amparoLegalObrigacao"
            name="amparoLegalObrigacao"
            optionLabel="descAmparoLegal"
            //optionValue='idenTipoAto'
            options={amparoLegal}
            value={formik.values.amparoLegalObrigacao}
            onChange={(e) => {
              formik.handleChange(e);
            }}
            disabled={flagValidaDadosCertidao ? true : false}
            placeholder="Selecione..."
            className={"campoTamanhoCompleto " + classNames({ "p-invalid": isFormFieldValid("amparoLegalObrigacao", formik) })}
          />
          {getFormErrorMessage("amparoLegalObrigacao", formik)}
        </RotuloSeplag>
        <hr className="p-col-12" />
        {/* <RotuloSeplag nome="Orgão de origem obrigação:" cols="12 4">
          <label className="p-inputtext p-component p-disabled p-filled inputEditadonoSpan">{certidao.orgaoLotacaoCs.idenOrgao + " - " + certidao.orgaoLotacaoCs.nomeOrgao}</label>
        </RotuloSeplag>
        <RotuloSeplag nome="Novo orgão de origem obrigação:" cols="12 6">
          <Dropdown
            filter
            id="orgao"
            name="orgao"
            optionLabel="descOrgao"
            //optionValue='idenTipoAto'
            disabled={flagValidaDadosCertidao ? true : false}
            options={orgaos}
            value={formik.values.orgao}
            onChange={(e) => {
              formik.handleChange(e);
            }}
            placeholder="Selecione..."
            className={"campoTamanhoCompleto " + classNames({ "p-invalid": isFormFieldValid("orgao", formik) })}
          />
          {getFormErrorMessage("orgao", formik)}
        </RotuloSeplag> */}
        <hr className="p-col-12" />
        <RotuloSeplag nome="Data quitação:" cols="12 2">
          <InputMask
            value={formik.values.dataQuitacaoCert}
            mask="99/99/9999"
            onComplete={(e) => {
              formik.handleChange(e);
            }}
            className={classNames({ "p-invalid": isFormFieldValid("dataQuitacaoCert", formik) })}
            id="dataQuitacaoCert"
            disabled={flagValidaDadosCertidao ? true : false}
          />
          {getFormErrorMessage("dataQuitacaoCert", formik)}
        </RotuloSeplag>
        <RotuloSeplag nome="Data autenticação:" cols="12 2">
          <InputMask
            value={formik.values.dataAutenticCert}
            mask="99/99/9999"
            onComplete={(e) => {
              formik.handleChange(e);
            }}
            className={classNames({ "p-invalid": isFormFieldValid("dataAutenticCert", formik) })}
            id="dataAutenticCert"
            disabled={flagValidaDadosCertidao ? true : false}
          />
          {getFormErrorMessage("dataAutenticCert", formik)}
        </RotuloSeplag>
        <RotuloSeplag nome="Data compensação:" cols="12 2">
          <InputMask
            value={formik.values.dataCompensCert}
            mask="99/99/9999"
            onComplete={(e) => {
              formik.handleChange(e);
            }}
            className={classNames({ "p-invalid": isFormFieldValid("dataCompensCert", formik) })}
            id="dataCompensCert"
            disabled={flagValidaDadosCertidao ? true : false}
          />
          {getFormErrorMessage("dataCompensCert", formik)}
        </RotuloSeplag>
        <RotuloSeplag nome="Data emissão:" cols="12 2">
          <InputMask
            value={formik.values.dataEmissaoCert}
            mask="99/99/9999"
            onComplete={(e) => {
              formik.handleChange(e);
            }}
            className={classNames({ "p-invalid": isFormFieldValid("dataEmissaoCert", formik) })}
            id="dataEmissaoCert"
            disabled={flagValidaDadosCertidao ? true : false}
          />
          {getFormErrorMessage("dataEmissaoCert", formik)}
        </RotuloSeplag>
        <RotuloSeplag nome="Data entrega:" cols="12 2">
          <InputMask
            value={formik.values.dataEntregaCert}
            mask="99/99/9999"
            onComplete={(e) => {
              formik.handleChange(e);
            }}
            className={classNames({ "p-invalid": isFormFieldValid("dataEntregaCert", formik) })}
            id="dataEntregaCert"
            disabled={flagValidaDadosCertidao ? true : false}
          />
          {getFormErrorMessage("dataEntregaCert", formik)}
        </RotuloSeplag>
        <hr className="p-col-12" />
        <RotuloSeplag nome="Numero processo quitação:" cols="12 3">
          <InputText value={formik.values.numrProcessoCompensacao} id="numrProcessoCompensacao" disabled={flagValidaDadosCertidao ? true : false} onChange={(e) => formik.handleChange(e)} />
          {getFormErrorMessage("numrProcessoCompensacao", formik)}
        </RotuloSeplag>
        <RotuloSeplag nome="Numero processo autenticação:" cols="12 3">
          <InputText value={formik.values.numrProcessoAutenticacao} id="numrProcessoAutenticacao" disabled={flagValidaDadosCertidao ? true : false} onChange={(e) => formik.handleChange(e)} />
          {getFormErrorMessage("numrProcessoAutenticacao", formik)}
        </RotuloSeplag>
        <RotuloSeplag nome="Numero processo compensação:" cols="12 3">
          <InputText value={formik.values.numrProcessoCompensacao} id="numrProcessoCompensacao" disabled={flagValidaDadosCertidao ? true : false} onChange={(e) => formik.handleChange(e)} />
          {getFormErrorMessage("numrProcessoCompensacao", formik)}
        </RotuloSeplag>
        <RotuloSeplag nome="Numero processo SAD:" cols="12 3">
          <InputText value={formik.values.numrProcessoSad} id="numrProcessoSad" disabled={flagValidaDadosCertidao ? true : false} onChange={(e) => formik.handleChange(e)} />
          {getFormErrorMessage("numrProcessoSad", formik)}
        </RotuloSeplag>
        <hr className="p-col-12" />
        <RotuloSeplag nome="Valor correção:" cols="12 2">
          <label className="p-inputtext p-component p-disabled p-filled inputEditadonoSpan">{(certidao.valrCorrecao).toLocaleString("pt-BR", { style: "currency", currency: "BRL" })}</label>
        </RotuloSeplag>
        <RotuloSeplag nome="Valor multa:" cols="12 2">
          <label className="p-inputtext p-component p-disabled p-filled inputEditadonoSpan">{(certidao.valrMulta).toLocaleString("pt-BR", { style: "currency", currency: "BRL" })}</label>
        </RotuloSeplag>
        <RotuloSeplag nome="Valor compensado:" cols="12 2">
          <label className="p-inputtext p-component p-disabled p-filled inputEditadonoSpan">{(certidao.valrCompensado).toLocaleString("pt-BR", { style: "currency", currency: "BRL" })}</label>
        </RotuloSeplag>
        <RotuloSeplag nome="Valor honorario advocatício:" cols="12 2 3">
          <label className="p-inputtext p-component p-disabled p-filled inputEditadonoSpan">{(certidao.valrHonAdv).toLocaleString("pt-BR", { style: "currency", currency: "BRL" })}</label>
        </RotuloSeplag>
        <RotuloSeplag nome="Valor remanescente:" cols="12 2">
          <label className="p-inputtext p-component p-disabled p-filled inputEditadonoSpan">{(certidao.valrRemanescente).toLocaleString("pt-BR", { style: "currency", currency: "BRL" })}</label>
        </RotuloSeplag>
        <hr className="p-col-12" />
        <RotuloSeplag nome="Valor bruto:" cols="12 2">
          <label className="p-inputtext p-component p-disabled p-filled inputEditadonoSpan">{(certidao.valrBruto).toLocaleString("pt-BR", { style: "currency", currency: "BRL" })}</label>
        </RotuloSeplag>
        <RotuloSeplag nome="Valor desconto:" cols="12 2">
          <label className="p-inputtext p-component p-disabled p-filled inputEditadonoSpan">{(certidao.valrDesconto).toLocaleString("pt-BR", { style: "currency", currency: "BRL" })}</label>
        </RotuloSeplag>
        <RotuloSeplag nome="Valor liquido:" cols="12 2">
          <label className="p-inputtext p-component p-disabled p-filled inputEditadonoSpan">{(certidao.valrLiquido).toLocaleString("pt-BR", { style: "currency", currency: "BRL" })}</label>
        </RotuloSeplag>
        <hr className="p-col-12" />
        <RotuloSeplag nome="Complemento:" cols="12">
          <label className="p-inputtext p-component p-disabled p-filled inputEditadonoSpan">{certidao.descProcessoSad}</label>
        </RotuloSeplag>
        <hr className="p-col-12" />
        {!flagValidaDadosCertidao && <Button type="submit" label="Validar Dados Certidão" icon="pi pi-check" className="p-button-success botaoValidarCertidao" disabled={flagValidaDadosCertidao ? true : false} />}
      </form>
    </CardSeplag>
  );
};

export { CertidaoViewDadosCertidao };
